<template>
  <div>
    <div class="sign-in-item" v-if="data.type === 'Checked'">
    <div class="text">
      {{ data.index }}天
    </div>
    <img class="icon" src="@/assets/image/home/sign-in/icon_1.webp" alt="">
  </div>
  <div class="sign-in-item Missed" v-if="data.type === 'Missed'">
    <div class="text">
      {{ data.index }}天
    </div>
    <img class="icon" src="@/assets/image/home/sign-in/icon_4.png" alt="">
  </div>
  <div class="sign-in-item Today" v-if="data.type === 'Today'">
    <div class="text">
      今天
    </div>
    <img class="icon" src="@/assets/image/home/sign-in/icon_3.webp" alt="">
  </div>
  <div class="sign-in-item NotChecked" v-if="data.type === 'NotChecked'">
    <div class="text">
      {{ data.index }}天
    </div>
    <img class="icon" src="@/assets/image/home/sign-in/icon_2.png" alt="">
  </div>
  </div>
 
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        type: '',
        index: 0,
        checkInId: 0
      })
    }
  },
  components: {},
  data() {
    return {};
  },
  created() { },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.sign-in-item {
  width: 36px;
  height: 52px;
  border-radius: 4px;
  background: #e8f3ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .text {
    font-family: "Noto Sans SC";
    font-size: 10px;
    font-weight: 350;
    line-height: normal;
    letter-spacing: 0em;

    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #262626;
  }

  .icon {
    width: 22px;
    height: 22px;
    margin-top: 4px;
  }
}

.Missed {
  background: #F2F3F5;

  border: 1px dashed #F45858;
  .text{
    color: #999999;
  }
}
.Today{
  background: #0062FF;
  .text{
    color: #FFFFFF;
  }
  .icon {
    width: 16px;
    height: 22px;
  }
}
.NotChecked{
  background: #F2F3F5;
}
</style>
